/**
 * Created by mgoria on 8/4/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Action = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _UnknownMethodException = require('./Exception/UnknownMethodException');

var _Request = require('./Request');

var _LocalRequest = require('./LocalRequest');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Resource action
 */
let Action = exports.Action = function () {
  /**
   * @param {Instance} resource
   * @param {String} name
   * @param {String} type
   * @param {Array} methods
   * @param {Object} source
   * @param {String} region
   * @param {Boolean} forceUserIdentity
   * @param {Object} apiCache
   * @param {String} scope
   * @param {Object} api
   */
  function Action(resource, name, type, methods, source, region, forceUserIdentity, apiCache, scope, api) {
    _classCallCheck(this, Action);

    this._resource = resource;
    this._name = name;
    this._type = type;
    this._methods = methods;
    this._source = source;
    this._region = region;
    this._forceUserIdentity = forceUserIdentity;
    this._apiCacheEnabled = apiCache && apiCache.hasOwnProperty('enabled') ? apiCache.enabled : false;
    this._apiCacheTtl = apiCache && apiCache.hasOwnProperty('ttl') ? apiCache.ttl : _Request.Request.TTL_INVALIDATE;
    this._scope = scope;
    // setup AWS_IAM as default auth type for back compatibility
    this._apiAuthType = api && api.hasOwnProperty('authorization') ? api.authorization : Action.API_AWS_IAM_AUTH;
    this._apiKeyRequired = api && api.hasOwnProperty('keyRequired') ? api.keyRequired : false;

    this._validationSchemaName = null;
    this._baseUrl = null;
  }

  /**
   * @param {String|null} url
   */


  _createClass(Action, [{
    key: 'request',


    /**
     * @param {Object} payload
     * @param {String} method
     * @returns {LocalRequest|Request}
     */
    value: function request() {
      let payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      let method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      method = method || (this._methods.length > 0 ? this._methods[0] : Action.HTTP_VERBS[0]);

      if (this._methods.length > 0 && this._methods.indexOf(method) === -1) {
        throw new _UnknownMethodException.UnknownMethodException(method, this._methods);
      }

      let RequestImplementation = this._resource.localBackend ? _LocalRequest.LocalRequest : _Request.Request;
      let requestObject = new RequestImplementation(this, payload, method);

      requestObject.validationSchemaName = this._validationSchemaName;

      if (this._resource.cache) {
        requestObject.cacheImpl = this._resource.cache;
      }

      return requestObject;
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'baseUrl',
    set: function set(url) {
      this._baseUrl = url;
    }

    /**
     * @returns {String|null}
     */
    ,
    get: function get() {
      return this._baseUrl;
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'validationSchemaName',
    get: function get() {
      return this._validationSchemaName;
    }

    /**
     * @param {String} validationSchemaName
     */
    ,
    set: function set(validationSchemaName) {
      this._validationSchemaName = validationSchemaName;
    }
  }, {
    key: 'sourceId',
    get: function get() {
      return this._type === Action.LAMBDA ? this._source.original : this._source.api;
    }

    /**
     * @returns {Boolean}
     */

  }, {
    key: 'forceUserIdentity',
    get: function get() {
      return this._forceUserIdentity;
    }

    /**
     * @returns {Instance}
     */

  }, {
    key: 'resource',
    get: function get() {
      return this._resource;
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'name',
    get: function get() {
      return this._name;
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'type',
    get: function get() {
      return this._type;
    }

    /**
     * @returns {Array}
     */

  }, {
    key: 'methods',
    get: function get() {
      return this._methods;
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'source',
    get: function get() {
      return this._source;
    }

    /**
     * @returns {Boolean}
     */

  }, {
    key: 'isOriginalSourceInvokable',
    get: function get() {
      return !!this._source.original;
    }

    /**
     * @returns {Boolean}
     */

  }, {
    key: 'isApiSourceInvokable',
    get: function get() {
      return !!this._source.api;
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'region',
    get: function get() {
      return this._region;
    }

    /**
     * @returns {Boolean}
     */

  }, {
    key: 'apiCacheEnabled',
    get: function get() {
      return this._apiCacheEnabled;
    }

    /**
     * @returns {Number}
     */

  }, {
    key: 'apiCacheTtl',
    get: function get() {
      return this._apiCacheTtl;
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'scope',
    get: function get() {
      return this._scope;
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'apiAuthType',
    get: function get() {
      return this._apiAuthType;
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'apiKeyRequired',
    get: function get() {
      return this._apiKeyRequired;
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'fullName',
    get: function get() {
      return `@${this._resource.microservice.identifier}:${this._resource.name}:${this._name}`;
    }

    /**
     * @returns {Array}
     */

  }], [{
    key: 'HTTP_VERBS',
    get: function get() {
      return ['GET', 'POST', 'DELETE', 'HEAD', 'PUT', 'OPTIONS', 'PATCH'];
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'LAMBDA',
    get: function get() {
      return 'lambda';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'EXTERNAL',
    get: function get() {
      return 'external';
    }

    /**
     * @returns {string}
     */

  }, {
    key: 'DEEP_CACHE_QS_PARAM',
    get: function get() {
      return '_deepQsHash';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'API_AWS_IAM_AUTH',
    get: function get() {
      return 'AWS_IAM';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'API_NONE_AUTH',
    get: function get() {
      return 'NONE';
    }
  }]);

  return Action;
}();


//////////////////
// WEBPACK FOOTER
// ../~/deep-resource/lib.compiled/Resource/Action.js
// module id = 95
// module chunks = 0